var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-height":"620px","overflow-y":"auto","overflow-x":"hidden"}},[_c('Table',{attrs:{"stripe":"","size":"small","data":_vm.historyList,"columns":_vm.tableColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }